/**
 *  @class
 *  @function HeroSplit
 */

if (!customElements.get('hero-split')) {
  class HeroSplit extends HTMLElement {
    constructor() {
      super();

      this.tl = false;
      this.splittext = false;
    }
    connectedCallback() {
      if (document.body.classList.contains('animations-true') && typeof gsap !== 'undefined') {
        this.prepareAnimations();
      }
    }
    disconnectedCallback() {
      if (document.body.classList.contains('animations-true') && typeof gsap !== 'undefined') {
        this.tl.kill();
        this.splittext.revert();
      }
    }
    prepareAnimations() {
      let section = this,
        button_offset = 0;

      section.tl = gsap.timeline({
        scrollTrigger: {
          trigger: section,
          start: "top center"
        }
      });

      document.fonts.ready.then(function () {
        // Only the heading gets the line-split slide-up reveal. The Text
        // block is intentionally left out of SplitText: splitting it
        // forces its lines into overflow:hidden mask elements, which
        // clips anything extending below the line box - including a
        // link's underline. It gets a plain fade-in instead, below.
        section.splittext = new SplitText(section.querySelectorAll('.hero-split--heading'), {
          type: 'lines, words',
          linesClass: 'line-child'
        });

        if (section.querySelector('.inline-badge')) {
          section.tl
            .fromTo(section.querySelector('.inline-badge'), {
              opacity: 0
            }, {
              duration: 0.75,
              opacity: 1
            }, 0);

          button_offset += 0.5;
        }
        if (section.querySelector('.subheading')) {
          section.tl
            .fromTo(section.querySelector('.subheading'), {
              opacity: 0
            }, {
              duration: 0.75,
              opacity: 0.6
            }, 0);

          button_offset += 0.5;
        }
        if (section.querySelector('.hero-split--heading')) {
          let h_duration = 0.8 + ((section.querySelectorAll('.hero-split--heading .line-child div').length - 1) * 0.08);
          section.tl
            .set(section.querySelector('.hero-split--heading'), {
              visibility: 'visible'
            }, 0)
            .from(section.querySelectorAll('.hero-split--heading .line-child div'), {
              duration: h_duration,
              yPercent: '100',
              stagger: 0.08
            }, 0);
          button_offset += h_duration;
        }
        if (section.querySelector('.rte p')) {
          section.tl
            .fromTo(section.querySelectorAll('.rte p'), {
              opacity: 0
            }, {
              duration: 0.75,
              opacity: 1
            }, 0);

          button_offset += 0.5;
        }
        if (section.querySelectorAll('.button')) {
          let i = 1;
          section.querySelectorAll('.button').forEach((item) => {
            section.tl.fromTo(item, {
              autoAlpha: 0
            }, {
              duration: 0.5,
              autoAlpha: 1
            }, ((button_offset * 0.4) + (i - 1) * 0.1));
            i++;
          });
        }
      });
    }
  }
  customElements.define('hero-split', HeroSplit);
}